import { formatDashboardFilterDate } from '../../utils/dashboard/dateFilterFormat';
import { createAction } from '../../utils/redux/createAction';
import * as appointmentList from './requests/appointment-list-req';
import { DASHBOARD_FILTER_TYPES } from './filter-types';

export const dashboardFilterActions = {
  setFilter: createAction(DASHBOARD_FILTER_TYPES.SET_FILTER),
  addDisplayableByDefault: createAction(
    DASHBOARD_FILTER_TYPES.ADD_DISPLAYABLE_BY_DEFAULT,
  ),
};

const initialState = {
  date: formatDashboardFilterDate(new Date()),
  locations: [],
  services: [],
  statuses: [],
  filterLoaded: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case DASHBOARD_FILTER_TYPES.ADD_DISPLAYABLE_BY_DEFAULT: {
      return {
        ...state,
        ...payload,
        filterLoaded: true,
      };
    }
    case DASHBOARD_FILTER_TYPES.SET_FILTER: {
      return {
        ...state,
        ...payload,
      };
    }
    case appointmentList.consts.PAGE_LEAVE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/dashboard/filter.js